
import { computed, defineComponent } from "vue";
import { useRouter } from "vue-router";
import { IonItem } from "@ionic/vue";
import { useI18n } from 'vue-i18n';
import {useToast} from "vue-toastification";
import useBackendFetch from "@/repositories/BackendFetch";
export default defineComponent({
  name: "MenuItem",
  components: {
    IonItem,
  },
  props: ["item"],
  setup(props) {
    const {t}=useI18n();
    const router = useRouter();
    const active = computed(() =>
      router.currentRoute.value.path.startsWith(props.item.href)
    );
    const toast = useToast();
    const handleLink = async (item) => {
      const { data, error } = await useBackendFetch(item.url).json();
      console.log(error, data);
      if (error.value) {
          toast.error(error.value.message);
      } else {
          toast.success(t('response.' + item.name))
      }
    }
    return {
      active,
      t,
      handleLink
    };
  },
});
